import { Box, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardButton } from "../buttons/StandardButton"
import { StandardDialog } from "../dialogs/StandardDialog"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "2rem",
        paddingTop: "1rem",
    },
    description: {
        color: theme.palette.text.primary,
    },
    buttonContainer: {
        marginTop: "4rem",
        display: "flex",
        justifyContent: "center",
    },
    closeButton: {
        minWidth: "6.125rem",
        fontSize: "0.875rem",
        padding: "1.063rem 2rem",
        borderRadius: "0.5rem",
    },
}))

type ProductUnavailableDialogProps = Readonly<{
    open: boolean
    onClose: () => void
    title: string
    message: string
}>

export function ProductUnavailableDialog({ open, onClose, title, message }: ProductUnavailableDialogProps) {
    const { classes } = useStyles()

    return (
        <StandardDialog open={open} onClose={onClose} dialogTitle={title} subtitle={message} maxWidthProp="sm">
            <Box className={classes.container}>
                {/* <Stack gap="1.5rem">
                    <Typography variant="body1" className={classes.description}>
                        {message}
                    </Typography>
                </Stack> */}

                {/* <Box className={classes.buttonContainer}>
                    <LocalizedStrict id="product-unavailable-dialog-close">
                        <StandardButton
                            variant="contained"
                            fullWidth={false}
                            onClick={onClose}
                            className={classes.closeButton}
                        >
                            Close
                        </StandardButton>
                    </LocalizedStrict>
                </Box> */}
            </Box>
        </StandardDialog>
    )
}
